import { useTranslation } from '@/i18n';

export const useErrorTranslation = () => {
  return useTranslation('errors').t;
};
